import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/profile.svg';
import { Icon } from '../Icon/Icon';
export const ProfileIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
